import React from 'react';
import MicrosoftOfficeImage from 'assets/images/ms-sql-office.svg';
import MicrosoftProductImage from 'assets/images/ms-products.svg';
import { useTranslation } from 'react-i18next';
import * as Styles from './NewVMPage.style';
import Heading from 'components/Heading/Heading';

const NewVMPage = () => {
  const { t } = useTranslation();
  return (
    <Styles.NewVMPageSC>
      <Heading name={'vs/instance/create.string1'}>
        <Styles.StepDescription>
          <Styles.Image>
            <img src={MicrosoftOfficeImage} alt="Microsoft Office" />
          </Styles.Image>
          <Styles.Description>
            <Styles.Paragraph>{t('vs/instance/create.string2')}</Styles.Paragraph>
            <Styles.Img src={MicrosoftProductImage} alt="microsoft products" />
          </Styles.Description>
        </Styles.StepDescription>
      </Heading>
    </Styles.NewVMPageSC>
  );
};
export default NewVMPage;
